import React from "react";
import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

const PHONE = "917814854580";
const TEXT = encodeURIComponent("Hi Bholaa Jewels! I visited your online catalogue and would love to know more about your collection.");

export default function FloatingWhatsApp() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  return (
    <a
      href={`https://wa.me/${PHONE}?text=${TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      className="group fixed bottom-28 right-8 z-[55] flex items-center justify-center w-14 h-14 rounded-full shadow-2xl"
      style={{ background: "#25D366" }}
      title="Chat with us on WhatsApp"
      data-testid="floating-whatsapp"
    >
      <span className="absolute inset-0 rounded-full animate-ping" style={{ background: "#25D366", opacity: 0.35 }} />
      <MessageCircle className="w-7 h-7 text-white relative z-10" strokeWidth={2} />
      <span className="absolute right-full mr-3 px-3 py-1.5 bg-ink-800 text-ivory text-xs whitespace-nowrap border border-rose-gold/30 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us on WhatsApp
      </span>
    </a>
  );
}
